import { TFunction } from 'i18next';
import { formatDecimal } from './formatDecimal';

// Zero VAT rate is displayed as "Without VAT" instead of "0%"
export const formatVatRate = (percent: number | null | undefined, t: TFunction): string =>
  percent ? `${formatDecimal(percent)}%` : t('Without VAT');

// Price details row: "VAT (20%) — amount", or "VAT — Without VAT" for zero rate
export const getVatRateRow = <T>(
  t: TFunction,
  percent: number | null | undefined,
  value: T,
  labelKey = 'VAT ({{vatRatePercent}}%)',
  plainLabelKey = 'VAT',
): { label: string; value: T | string } =>
  percent ? { label: t(labelKey, { vatRatePercent: percent }), value } : { label: t(plainLabelKey), value: formatVatRate(percent, t) };
